module.exports = __webpack_public_path__ + "img/time-line-edit.debcc816.svg";